import {attr, controller, target} from '@github/catalyst'
import {currencyFormatter, getUnitData} from './utils'
import type {UnitData} from './utils'

@controller
export class GhasCalculatorElement extends HTMLElement {
  @target declare committerCountInput: HTMLInputElement
  get committerCount() {
    return parseInt(this.committerCountInput.value) || 0
  }

  @target declare committerSeatCostDisplay: HTMLElement
  @target declare costPerMonthDisplay: HTMLElement

  @attr costPerMonth = 0
  @attr committerSeatCost = 0
  @attr active = false

  declare unit_data: UnitData

  connectedCallback() {
    this.unit_data = getUnitData()
  }

  updateCommitterSeatCost() {
    this.committerSeatCost = this.calculateCommitterSeatCost(this.committerCount)
  }

  calculateCommitterSeatCost(committerCount: number) {
    const perSeatCost = this.unit_data.ghas_committer_seat!.value || 0
    return perSeatCost * committerCount
  }

  calculateSelfHostedCost() {
    return 0
  }

  updateMonthlyCost() {
    this.costPerMonth = this.committerSeatCost
  }

  displayCost(displayElement: HTMLElement, price: number) {
    displayElement.textContent = currencyFormatter.format(price / 100)
  }

  resetButtonClicked(event: PointerEvent) {
    event.preventDefault()
    this.committerCountInput.value = ''
    this.committerSeatCost = 0
    this.costPerMonth = 0
  }

  getSummaryForCSV() {
    // headers: ['Service', 'Configuration Summary', 'Notes', 'Cost Per Month']

    return [
      [
        'GitHub Advanced Security',
        `"Committer Count: ${this.committerCount}"`,
        `"Committer Seat Cost Per Month: ${currencyFormatter.format(this.committerSeatCost / 100)}"`,
        `"${currencyFormatter.format(this.costPerMonth / 100)}"`,
      ],
    ]
  }

  static observedAttributes = ['data-committer-seat-cost', 'data-cost-per-month', 'data-active']
  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null): void {
    if (oldValue === newValue) {
      return
    }

    if (name === 'data-committer-seat-cost') {
      this.displayCost(this.committerSeatCostDisplay, this.committerSeatCost)
      this.updateMonthlyCost()
    }

    if (name === 'data-cost-per-month' || name === 'data-active') {
      this.displayCost(this.costPerMonthDisplay, this.costPerMonth)
      document.dispatchEvent(
        new CustomEvent('subtotalChanged', {
          detail: {sectionName: 'ghasTotal', amount: this.costPerMonth, active: this.active},
        }),
      )
    }

    if (name === 'data-cost-per-month') {
      document.dispatchEvent(
        new CustomEvent('formDataUpdated', {
          detail: {
            sectionName: 'ghas',
            resetEnabled: Boolean(this.costPerMonth),
          },
        }),
      )
    }
  }
}
